import React from 'react';
import cn from 'classnames';

import {useAccordion} from 'brandComponents/Accordion/AccordionContext';

import {IAccordionContentProps} from './IAccordionContent';

import styles from './AccordionContent.module.scss';

const AccordionContent = ({children, classNames}: IAccordionContentProps) => {
	const {togglerRef, isOpen} = useAccordion();

	return (
		<div
			className={cn(
				'accordion__content',
				classNames,
				styles['accordion_content'],
				isOpen ? 'accordion_content--expanded' : 'accordion_content--collapsed',
				isOpen ? styles['accordion_content--expanded'] : styles['accordion_content--collapsed'],
			)}
			ref={togglerRef}
		>
			{children}
		</div>
	);
};

export default AccordionContent;
